export default class FinesseSearch extends HTMLElement {
  active: boolean = false

  search: HTMLElement
  form: HTMLElement
  formSubmit: HTMLElement
  closeButton: HTMLElement

  static get observedAttributes() {
    return ['active']
  }

  constructor() {
    super()

    this.className = 'fixed top-0 right-[-100vw] flex justify-end z-50 w-full h-full transition-opacity duration-500 opacity-0'

    this.search = this.querySelector<HTMLElement>('aside[data-search]') as HTMLElement
    this.form = this.querySelector<HTMLElement>('form[data-search-form]') as HTMLElement
    this.formSubmit = this.querySelector<HTMLElement>('button[data-search-submit]') as HTMLElement
    this.closeButton = this.querySelector<HTMLElement>('button[data-search-close]') as HTMLElement

    this.closeButton.addEventListener('click', this.handleClose.bind(this))

    this.addEventListener('click', this.handleClose) as any

    (window as any).addEventListener('search:toggle', this.handleCart.bind(this))
    this.form.addEventListener('submit', this.handleSubmit.bind(this))
    this.formSubmit.addEventListener('click', this.handleSubmit.bind(this))
  }
  
  get isActive() {
    return this.active
  }

  set isActive(value: boolean) {
    this.active = value
    this.setAttribute('active', value.toString())
    this.toggle()
  }

  handleCart(evt: CustomEvent) {
    // @ts-ignore
    this.isActive = evt.detail.active
  }

  handleSubmit(evt: Event) {
    evt.preventDefault()

    const formData = new FormData(this.form as HTMLFormElement)
    const search = formData.get('q') as string

    const searchUrl = `/search?q=${search}`

    window.location.href = searchUrl
  }

  handleClose(evt: Event) {
    evt.preventDefault()

    const isCloseButton = evt.target === this.closeButton || (evt.target as HTMLElement).hasAttribute('data-search-close')
 
    if (evt.target === this || isCloseButton) {
      window.dispatchEvent(new CustomEvent('search:toggle', { bubbles: true, detail: { active: false } }))
    }
  }

  toggle() {
    if (this.isActive) {
      this.classList.add('!right-0', '!opacity-100')
    } else {
      this.classList.remove('!right-0', '!opacity-100')
    }
  }
}

customElements.define('finesse-search', FinesseSearch)
